import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useNavigate } from "react-router-dom";
import MobileSideNavbar from "../../Components/MobileSideNavbar/MobileSideNavbar";
import SideNavbar from "../../Components/SideNavbar/SideNavbar";
import TopNavbar from "../../Components/TopNavbar/TopNavbar";
import { MdKeyboardArrowUp } from "react-icons/md";
import { arrayToOptions } from "../../Services/GeneralFunctions";
import {
  GetDropDownApi,
  GetSingleEmployeeData,
} from "../../Services/CommonApis";
import { notification } from "antd";

export default function User() {
  const [api, contextHolder] = notification.useNotification();

  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const [dropDowns, setDropDowns] = useState(null);
  const [profileData, setProfileData] = useState(null);

  const navigate = useNavigate(null);

  const getAllDropDowns = async () => {
    try {
      const data = await GetDropDownApi();

      if (data.data.success) {
        let optionsArray = {};
        data.data.data.map(
          (val) => (optionsArray[val.field] = arrayToOptions(val.value))
        );
        setDropDowns(optionsArray);
      } else {
        api.error({
          message: "Error while fetching dropdowns",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  useEffect(() => {
    // navigate("/user/Employee");
    isLoggedIn();
    getAllDropDowns();
  }, []);

  useEffect(() => {
    isLoggedIn();
  });

  const isLoggedIn = () => {
    if (sessionStorage.getItem("isLoggedIn") === "true") {
      // if (sessionStorage.getItem("userType") !== "user") {
      //   navigate(-1);
      // }
    } else {
      navigate("/auth");
    }
  };

  return (
    <>
      {contextHolder}
      <Helmet>
        <style>{`body {
        background: #F4F4F9;
      
        }`}</style>
      </Helmet>

      <MobileSideNavbar
        type="user"
        isNavbarOpen={isNavbarOpen}
        setIsNavbarOpen={setIsNavbarOpen}
      />
      <SideNavbar type="user" />

      <div id="dashboard-body" style={{ margin: "0px 0px 0px 256px" }}>
        <TopNavbar type="user" setIsNavbarOpen={setIsNavbarOpen} />

        <div className="dashboard-subbody mt-3">
          <Outlet context={{ dropDowns, profileData }} />
          <div
            className="text-center go-to-top"
            onClick={() => window.scrollTo(0, 0)}
          >
            <MdKeyboardArrowUp style={{ fontSize: "40px" }} />
          </div>
        </div>
      </div>
    </>
  );
}
